import React from 'react';

function RMTextInput({
  style,
  placeHolder,
  onChange,
  value,
  className = '',
  readOnly = false,
}) {
  return (
    <input
      id={`controls-rmtextinput-wrapper`}
      data-testid={`controls-rmtextinput-wrapper`}
      value={value}
      type="text"
      placeholder={placeHolder}
      onChange={onChange}
      style={{
        padding: '5px 6.32px',
        fontSize: '0.875rem',
        lineHeight: '1rem',
        ...style,
      }}
      className={className}
      readOnly={readOnly}
    />
  );
}

export default RMTextInput;
